$(function() {

    Fancybox.bind('.js-open-modal', {
        trapFocus: false,
        autoFocus: false,
        placeFocusBack: false,
        dragToClose: false,
      });

})